Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.apiContentType = "application/json"
exports.endPoint = "notifications/notifications";
exports.getDataMethod = "GET";
exports.markAsReadMethod = "PUT";
exports.deleteMethod = "DELETE";
exports.TOKEN = "token"
exports.notifications = "Notifications";
exports.deleteText = "DELETE"
exports.okText = "OK"
exports.deleteMessage = "Notifications deleted!"
exports.getNotification = "bx_block_notifications/notifications"
exports.readSingleNotification ="bx_block_notifications/notifications";
exports.readAllNotification = "bx_block_notifications/notifications/read_all_notification";
exports.myNotificationsTitle = "My Notifications";
exports.avatar1 = "https://s3-alpha-sig.figma.com/img/7a7c/9b75/b1020711ab8bb5a6fef3ca82c55b4e3f?Expires=1741564800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=aPWuuSnbjSbFfLLIKzfbyj3iQBPqQS3Rmb7zVQgfE0yuSZdIsBVIOyy7-pwOJSbxhIC5RdM10fpa5I6RutwFxhnnjFhdB1HUkgVBgwnf2HwC3KKCTQHufr981sWwZ~U--9leD-fiJ5YlzwaZScdjVMTYYKai0xelHdBSyawy4rZaHqKN-3IOwNtVX3GvDItnAj7JWAYpK3ZaNwJeOMLO7b3jXEcP-aACgutQegyaRJkWW5JFlGwvrLO9Wva5ggTdn4z3I7mKaLhi1ZAj5MNtZKbvS02zPwS737KwgRVeIGkFR7JXcE~WaIjNrY1~Y7zOfYQreZS~vEJxDG~64-qP~Q__";
exports.avatar2 = "https://s3-alpha-sig.figma.com/img/f0d1/f3cd/d69b712cbd703e3c35af59cab6bc90a6?Expires=1741564800&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=aYO~t4FcMGyx-jk7KmBCtt2bvQiXcXniQJbszxmvulcxvSAQ9vexehLCCS4Bt2QbJ0j9wcW8oU1hjhZo2QpvSmxppuTJdIyja~gTSBpjbDXSc38sp4F8oZcNjr3pRm7KYw53kLLL8RWZdfPjr6e1~ap6Pmqu8ABCZVR9bSrajBO3a9K~~Euy1hp8Vx8zfOgtlNLOLWImbEISzOqVVfy~4Vn3uj17ECbNN7cKAJpCMnSOFVTpbnM4fAmSeu0A6pKLhawKXl23WvnCYdOwQpwmVIIcNMDeArLQLcuTV-GYYAVq2FldmKz6cp~oYpi3erItjIS3wzf21LIcTIUeVJL1vg__";
// Customizable Area End